import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FreelancerUserIgnoredSurveyItem from '../../../Domain/FreelancerUserIgnoredSurveyItem';
import FreelancerUserIgnoredSurveyService from '../../../Services/FreelancerUserIgnoredSurveyService';
import ErrorMessage from '../../../Elements/ErrorMessage';

export default class FreelancerUserIgnoredSurveyAdmin extends React.Component {
  static defaultProps = {
    freelancerUserId: 0,
  };
  constructor(props) {
    super(props);
    this.state = {
      searchItem: { FreelancerUserId: this.props.freelancerUserId },
    };

    FreelancerUserIgnoredSurveyItem.ChangeIsActiveStatus = this.changeIsActiveStatus.bind(this);
  }

  changeIsActiveStatus(item) {
    FreelancerUserIgnoredSurveyService.ChangeIsActiveStatus(item).then((result) => {
      if (result.error) {
        ErrorMessage.SetErrorMessage(result.error);
        return;
      }
      ErrorMessage.SetSuccess('The status has been changed successfully.');
      this.setState({ searchItem: { ...this.state.searchItem } });
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={FreelancerUserIgnoredSurveyItem}
          serviceFunction={FreelancerUserIgnoredSurveyService.GetListBySearching}
          convertDBItemsFunction={FreelancerUserIgnoredSurveyService.ConvertDBItems}
          showSearchStrip={false}
          searchItem={this.state.searchItem}
          orderBy='ClientId'
          errorCode='FUISA22'
        />
      </div>
    );
  }
}
